export default __webpack_public_path__ + "static/media/mongodb.7e759441.png";